import { Component, Input, Output,EventEmitter,OnInit, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'teiasoft-chips',
  templateUrl: './teiasoft-chips.component.html',
  styleUrls: ['./teiasoft-chips.component.scss']
})
export class TeiasoftChipsComponent implements OnInit, OnChanges{
  @Input() values: any[] | null= new Array();
  @Input() value: any;
  @Input() readOnly: boolean = false;
  @Input() multiSelection?: boolean = false;
  @Input() allowSingleSelectionClear: boolean = false;
  
  @Output() deleteValue: EventEmitter<any> = new EventEmitter();

  ngOnInit(): void {
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes["values"]){
      this.values = new Array();
      if (changes["values"].currentValue == null) return;
      
      if (Array.isArray(changes["values"].currentValue))
        this.values =  changes["values"].currentValue;
      else
        this.values =  changes["values"].currentValue.split(',');
      if (this.multiSelection){
        if (this.values!.length == 1 && this.values![0] == '') 
        this.values = null;
      }
      //console.log("Values", this.values); 
    }

    if (changes && changes["value"]){
      this.value = changes["value"].currentValue;
    }
  }

  onDeleteValue(evt: Event, item:any){
    evt.preventDefault();
    evt.stopPropagation();
    if (item.toString().length == 0) return;
    this.deleteValue.emit(item);
  }
}
